import { render, staticRenderFns } from "./WTitle.vue?vue&type=template&id=62f023b0&scoped=true&lang=pug&"
import script from "./WTitle.vue?vue&type=script&lang=js&"
export * from "./WTitle.vue?vue&type=script&lang=js&"
import style0 from "./WTitle.vue?vue&type=style&index=0&id=62f023b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f023b0",
  null
  
)

export default component.exports